function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaoRooamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 433 105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.88769,0.344946)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.492,
    y: 3.281,
    width: 2.787,
    height: 97.336,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.52768,0,0,1.52768,1.12034,27.8501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.572,12.052L85.577,12.052C87.787,11.298 89.005,9.613 89.005,7.305C89.005,3.995 86.803,2.172 82.805,2.172L76.364,2.172L76.364,17.666L78.045,17.666L78.045,12.464L83.299,12.464L87.417,17.577L87.486,17.664L89.606,17.664L85.163,12.184L85.572,12.052ZM87.216,7.359C87.216,9.639 85.626,10.999 82.963,10.999L78.043,10.999L78.043,3.666L82.749,3.666C85.589,3.666 87.216,5.012 87.216,7.359Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.91,9.945C106.91,5.163 103.58,1.825 98.816,1.825C94.082,1.825 90.776,5.165 90.776,9.945C90.776,14.709 94.082,18.039 98.816,18.039C103.58,18.039 106.91,14.709 106.91,9.945ZM92.509,9.945C92.509,6.152 95.161,3.398 98.814,3.398C102.499,3.398 105.173,6.152 105.173,9.945C105.173,13.707 102.499,16.437 98.814,16.437C95.161,16.437 92.509,13.707 92.509,9.945Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.675,11.199C120.675,14.431 118.811,16.44 115.809,16.44C112.79,16.44 110.916,14.431 110.916,11.199L110.916,2.172L109.235,2.172L109.235,11.199C109.235,15.354 111.814,18.039 115.809,18.039C119.865,18.039 122.384,15.418 122.384,11.199L122.384,2.172L120.677,2.172L120.677,11.199L120.675,11.199Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.734,2.172L125.267,2.172L125.267,17.666L126.948,17.666L126.948,12.625L131.6,12.625C135.608,12.625 137.908,10.686 137.908,7.305C137.908,3.995 135.714,2.172 131.734,2.172ZM136.147,7.359C136.147,9.846 134.593,11.16 131.654,11.16L126.948,11.16L126.948,3.666L131.654,3.666C134.509,3.666 136.147,5.012 136.147,7.359Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.558,11.065L66.575,12.481L72.059,12.425L71.863,12.882C70.822,15.173 68.62,16.541 65.971,16.541C62.228,16.541 59.511,13.746 59.511,9.895C59.511,6.012 62.228,3.196 65.971,3.196C68.346,3.196 70.363,4.29 71.503,6.2L71.57,6.312L73.429,6.312L73.27,5.982C71.947,3.26 69.288,1.698 65.971,1.698C61.192,1.698 57.852,5.068 57.852,9.895C57.852,14.703 61.19,18.06 65.971,18.06C69.73,18.06 72.624,16.047 73.716,12.664L73.733,12.597C73.867,12.179 73.97,11.736 74.039,11.274L74.08,11.009L71.167,11.009L66.558,11.065Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.465,3.941C17.683,3.941 17.791,3.834 17.465,3.724C16.271,2.748 13.668,2.204 11.065,1.989C8.462,1.881 3.254,2.207 3.254,2.207C3.254,2.207 0,2.314 0,3.508C0.108,4.592 3.146,4.267 4.881,4.159C6.508,3.941 8.785,3.834 8.785,3.834C8.785,3.834 8.893,5.461 8.893,8.932C8.893,12.404 8.568,15.224 8.242,16.091C7.809,17.067 7.266,17.61 7.049,17.61C6.831,17.61 7.049,17.717 7.049,17.717C7.049,17.717 10.195,19.67 10.738,13.813C11.171,9.04 9.979,4.049 9.869,3.834C9.871,3.834 11.606,3.508 17.465,3.941Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.784,10.559C31.241,10.451 28.638,9.908 28.638,9.908C28.638,9.908 28.421,9.583 28.421,9.475C28.095,8.932 26.143,5.896 25.275,4.269C24.406,2.642 23.105,-0.287 22.887,0.254C22.887,0.254 21.152,5.027 20.066,8.499C19.958,8.717 19.741,9.475 19.741,9.475C19.308,9.475 17.138,9.583 16.052,9.367C14.968,9.15 13.449,8.499 13.882,10.018C14.315,11.537 19.198,11.427 19.198,11.427C19.198,11.427 19.415,11.21 18.547,13.272C17.791,15.332 16.271,19.021 16.271,19.021C16.271,19.021 15.728,19.997 16.489,19.347C17.465,18.588 19.418,15.983 20.937,11.97C21.044,11.537 21.154,11.32 21.154,11.32C21.372,11.32 26.796,11.212 26.796,11.212C26.796,11.212 27.447,12.513 27.88,13.707C28.205,14.791 28.205,15.767 28.856,15.442C29.507,15.117 30.05,14.033 29.074,11.212L29.074,11.104C29.074,11.104 30.7,11.322 31.351,11.104C31.784,11.102 32.325,10.777 31.784,10.559ZM21.913,9.475L21.695,9.475L23.322,3.293L23.54,3.726C23.54,3.726 25.059,7.848 26.251,9.693C25.925,9.691 22.346,9.365 21.913,9.475Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.319,3.941C44.474,2.207 41.546,1.121 37.967,2.422C37.859,2.53 37.859,2.53 37.967,2.53C41.438,2.204 43.173,3.073 45.017,4.7C46.427,6.109 47.405,8.389 47.187,10.557C46.97,13.27 45.453,15.655 42.197,16.306C37.641,16.849 35.254,14.028 34.928,10.99C34.711,8.712 35.579,6.325 37.314,5.241C38.723,4.265 37.965,3.614 37.965,3.614C37.965,3.614 37.206,2.963 35.469,4.698C33.735,6.217 32.974,8.712 33.299,11.205C33.732,15.002 36.771,18.474 42.628,17.823C47.183,16.955 48.81,13.701 48.92,10.447C49.032,7.738 47.948,5.461 46.319,3.941Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.655,28.703L32.965,28.703L32.965,26.43L32.108,26.43L32.108,31.694L32.965,31.694L32.965,29.507L35.655,29.507L35.655,31.694L36.521,31.694L36.521,26.43L35.655,26.43L35.655,28.703Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.947,26.32C41.374,26.32 40.275,27.451 40.275,29.069C40.275,30.657 41.397,31.812 42.947,31.812C44.505,31.812 45.636,30.66 45.636,29.069C45.636,27.451 44.528,26.32 42.947,26.32ZM44.761,29.069C44.761,30.186 44.015,30.966 42.947,30.966C41.906,30.966 41.149,30.168 41.149,29.069C41.149,27.962 41.906,27.156 42.947,27.156C44.015,27.158 44.761,27.944 44.761,29.069Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.204,28.569C50.142,28.274 49.956,28.085 49.956,27.798C49.956,27.32 50.504,27.149 51.014,27.149C51.883,27.149 52.374,27.542 52.379,27.544L52.456,27.606L52.924,26.884L52.868,26.833C52.844,26.811 52.279,26.318 51.014,26.318C49.788,26.318 49.058,26.873 49.058,27.804C49.058,28.701 49.717,29.067 50.857,29.399C51.926,29.707 52.105,29.914 52.105,30.263C52.105,30.856 51.501,30.981 50.997,30.981C50.099,30.981 49.566,30.515 49.562,30.511L49.489,30.446L49.015,31.112L49.064,31.164C49.09,31.19 49.696,31.81 51.006,31.81C52.262,31.81 53.012,31.222 53.012,30.237C53.014,29.401 52.506,28.934 51.204,28.569Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.934,26.43L56.753,26.43L56.753,31.694L57.611,31.694L57.611,30.091L58.893,30.091C60.227,30.091 61.024,29.395 61.024,28.231C61.024,27.087 60.261,26.43 58.934,26.43ZM60.14,28.248C60.14,28.938 59.727,29.287 58.908,29.287L57.608,29.287L57.608,27.242L58.908,27.242C59.369,27.242 60.14,27.373 60.14,28.248Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.679,
    y: 26.43,
    width: 0.858,
    height: 5.264,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.081,27.242L70.801,27.242L70.801,31.694L71.658,31.694L71.658,27.242L73.386,27.242L73.386,26.43L69.081,26.43L69.081,27.242Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.213,26.43L75.651,31.694L76.621,31.694L77.028,30.862L79.651,30.862L80.058,31.694L81.036,31.694L78.465,26.43L78.213,26.43ZM79.258,30.067L77.42,30.067L78.336,28.016L79.258,30.067Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.245,26.43L84.387,26.43L84.387,31.694L88.093,31.694L88.093,30.882L85.245,30.882L85.245,26.43Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.614,
    y: 26.43,
    width: 0.858,
    height: 5.264,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.019,27.242L97.739,27.242L97.739,31.694L98.596,31.694L98.596,27.242L100.324,27.242L100.324,26.43L96.019,26.43L96.019,27.242Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.649,28.634L105.556,28.83L105.464,28.625L104.134,26.43L103.13,26.43L105.108,29.688L105.108,31.694L105.975,31.694L105.975,29.679L107.963,26.43L106.966,26.43L105.649,28.634Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "rooamLogo-full-whiteText",
    transform: "matrix(2.22293,0,0,2.22293,248.73,-594.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_671",
    transform: "matrix(1,0,0,1,-373.076,-50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.607,337.3C453.588,337.3 454.707,338.661 454.571,340.793L454.132,347.008L450.82,347.008L451.198,341.594C451.258,340.794 450.956,340.218 450.215,340.218C449.607,340.231 449.077,340.645 448.915,341.231L448.507,347.008L445.226,347.008L445.604,341.594C445.664,340.794 445.362,340.218 444.621,340.218C444.012,340.227 443.478,340.642 443.321,341.231L442.913,347.008L439.6,347.008L440.25,337.527L443.562,337.527L443.501,338.298C444.163,337.632 445.072,337.269 446.011,337.298C446.989,337.25 447.934,337.672 448.551,338.432C449.385,337.675 450.481,337.269 451.607,337.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_672",
    transform: "matrix(1,0,0,1,-318.725,-50.409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.871,341.126C376.871,341.05 376.886,340.99 376.886,340.926C376.946,340.17 376.992,339.414 377.052,338.658C377.067,338.537 377.097,338.458 377.218,338.431C378.027,338.076 378.892,337.866 379.774,337.811C380.496,337.74 381.224,337.776 381.936,337.917C382.779,338.051 383.541,338.5 384.068,339.172C384.432,339.68 384.633,340.286 384.643,340.911C384.656,341.209 384.646,341.507 384.613,341.803C384.492,343.603 384.371,345.403 384.235,347.203C384.235,347.279 384.22,347.339 384.22,347.415L381.075,347.415C381.09,347.264 381.09,347.143 381.105,347.022C380.749,347.189 380.381,347.33 380.005,347.445C378.852,347.805 377.594,347.609 376.605,346.916C375.701,346.261 375.325,345.086 375.683,344.028C375.939,343.025 376.685,342.216 377.664,341.881C378.757,341.43 379.985,341.425 381.082,341.866C381.201,341.92 381.317,341.981 381.43,342.047C381.575,341.626 381.435,341.156 381.082,340.883C380.77,340.651 380.396,340.52 380.008,340.505C378.973,340.404 377.93,340.613 377.014,341.105C376.965,341.094 376.914,341.101 376.871,341.126ZM379.865,345.39C380.241,345.39 380.61,345.279 380.924,345.072C381.124,344.929 381.243,344.698 381.243,344.452C381.243,344.247 381.161,344.051 381.015,343.908C380.439,343.508 379.685,343.461 379.064,343.787C378.788,343.92 378.612,344.201 378.612,344.507C378.612,344.751 378.723,344.981 378.913,345.133C379.193,345.322 379.528,345.413 379.865,345.39Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_673",
    transform: "matrix(1,0,0,1,-163.682,-48.812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.968,336.928L197.044,335.9L193.581,335.9L192.901,345.79L196.364,345.79L196.742,340.361C197.332,338.123 199.388,339.287 199.388,339.287L200.84,336.58C199.657,335.69 197.973,335.842 196.968,336.928Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_674",
    transform: "matrix(1,0,0,1,-203.312,-49.831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.114,347.02C244.034,347.024 243.954,347.027 243.874,347.027C241.506,347.027 239.559,345.079 239.559,342.712C239.559,342.494 239.575,342.276 239.608,342.06C239.677,339.279 242.014,337.044 244.795,337.1C244.878,337.095 244.961,337.093 245.044,337.093C247.407,337.093 249.352,339.038 249.352,341.401C249.352,341.622 249.335,341.842 249.301,342.06C249.248,344.798 246.981,347.022 244.243,347.022C244.2,347.022 244.157,347.021 244.114,347.02ZM244.628,339.82C243.615,339.82 242.98,340.758 242.889,342.058C242.798,343.358 243.297,344.281 244.326,344.281C245.355,344.281 245.989,343.374 246.08,342.058C246.155,340.744 245.671,339.822 244.628,339.822L244.628,339.82Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_675",
    transform: "matrix(1,0,0,1,-261.284,-49.831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.414,347.02C312.334,347.024 312.254,347.027 312.174,347.027C309.806,347.027 307.859,345.079 307.859,342.712C307.859,342.494 307.875,342.276 307.908,342.06C307.977,339.279 310.314,337.044 313.095,337.1C313.178,337.095 313.261,337.093 313.344,337.093C315.707,337.093 317.652,339.038 317.652,341.401C317.652,341.622 317.635,341.842 317.601,342.06C317.548,344.798 315.281,347.022 312.543,347.022C312.5,347.022 312.457,347.021 312.414,347.02ZM312.928,339.82C311.915,339.82 311.28,340.758 311.189,342.058C311.098,343.358 311.597,344.281 312.626,344.281C313.655,344.281 314.289,343.374 314.38,342.058C314.455,340.744 313.971,339.822 312.928,339.822L312.928,339.82Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    transform: "matrix(1,0,0,1,-0.46,278.469)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.254,
    cy: 12.701,
    rx: 13.254,
    ry: 12.701,
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    transform: "matrix(1,0,0,1,2.694,281.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_676",
    transform: "matrix(1,0,0,1,-17.5,-295.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.632,295.9C22.108,295.9 17.55,300.417 17.5,305.941L17.5,306.047C17.5,311.613 22.081,316.194 27.647,316.194C33.213,316.194 37.794,311.613 37.794,306.047C37.794,300.481 33.213,295.9 27.647,295.9C27.642,295.9 27.637,295.9 27.632,295.9ZM27.632,297.926C29.967,297.923 32.191,298.933 33.726,300.693C33.219,300.548 32.695,300.471 32.168,300.466C30.348,300.467 28.64,301.361 27.601,302.855C26.253,300.908 23.8,300.029 21.522,300.677C23.075,298.935 25.298,297.933 27.632,297.926ZM27.632,314.152C23.188,314.146 19.533,310.491 19.527,306.047C19.527,305.835 19.542,305.624 19.557,305.412C19.86,303.723 21.344,302.482 23.06,302.482C25.009,302.482 26.614,304.083 26.619,306.032L26.347,309.056L27.632,309.963L28.917,309.056L28.645,306.032C28.645,306.012 28.645,305.992 28.645,305.972C28.645,304.023 30.249,302.418 32.199,302.418C34.148,302.418 35.753,304.023 35.753,305.972C35.753,305.992 35.752,306.012 35.752,306.032C35.745,310.484 32.084,314.145 27.632,314.152Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_677",
    transform: "matrix(1,0,0,1,-89.562,-342.413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.245,350.7C103.234,350.704 102.404,351.534 102.4,352.545C102.4,353.557 103.233,354.39 104.245,354.39C105.257,354.39 106.09,353.557 106.09,352.545C106.086,351.534 105.256,350.704 104.245,350.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_678",
    transform: "matrix(1,0,0,1,-38.295,-342.413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.845,350.7C42.834,350.704 42.004,351.534 42,352.545C42,353.557 42.833,354.39 43.845,354.39C44.857,354.39 45.69,353.557 45.69,352.545C45.69,352.544 45.69,352.544 45.69,352.543C45.69,351.532 44.858,350.7 43.847,350.7C43.846,350.7 43.846,350.7 43.845,350.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(22.9559,12.701,-12.701,22.9559,1.77604,6.3505)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(221,52,46)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(220,50,45)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "rgb(217,39,41)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(216,35,39)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaoRooamLogo);
export default __webpack_public_path__ + "static/media/tao-rooam-logo.e0050dceb75f4903c8429b9891623323.svg";
export { ForwardRef as ReactComponent };